// Returns the dynamic entry span immediately before the collapsed cursor, when the
// cursor sits right after it without actually being inside it (e.g. in the parent
// element right after the span, or at the very start of a text node that follows it).
export function getPrecedingDynamicSpan(rng: Range): HTMLElement | null {
	const { startContainer, startOffset } = rng;

	const node =
		startContainer.nodeType === Node.TEXT_NODE
			? startOffset === 0
				? startContainer.previousSibling
				: null
			: startOffset > 0
				? startContainer.childNodes[startOffset - 1]
				: null;

	return node?.nodeType === Node.ELEMENT_NODE && (node as Element).hasAttribute('data-id')
		? (node as HTMLElement)
		: null;
}
